import { useEffect } from 'react';

let { locationName } = window.ecom?.craftConfig;
locationName = locationName?.replace(/&#039;/g, "'");

export function useDocumentTitle(pageTitle) {
  useEffect(() => {
    if (pageTitle === undefined) {
      // Do nothing here, title will be valid soon
    } else if (pageTitle === 'accommodation') {
      document.title = `Best places to stay in ${locationName} | SeaLink ${locationName}`;
    } else if (pageTitle === 'default') {
      document.title = `Ferry, Accommodation, Holidays and Tours | SeaLink ${locationName}`;
    } else {
      document.title = `${pageTitle} | SeaLink ${locationName}`;
    }
  }, [pageTitle]);
}
